import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from "vue";
  import { useToast } from "vue-toastification";
  import { useStore } from "vuex";
  import { BuilderQuote } from "@/types/BuilderQuote";
  import { calculateBuildPriceOrPackagePriceTotal } from "@/helpers/builder/calculateBuildPriceOrPackagePriceTotal";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'PackageRow',
  props: {
    savedPackage: {
      type: Object,
      default: Object as () => BuilderQuote,
    },
    isDetailsPackageOpen: String,
    getEstateTitle: Function,
    getLandSize: Function,
    getBuildSize: Function,
    formatPrice: Function,
    getBedroomCount: Function,
    getBathroomCount: Function,
    getLoungeRoomCount: Function,
    getLotClass: Function,
    getLotStatus: Function,
    onClickPackage: Function,
    openDetailsPackage: Function,
    isDisplayDetailsEffect: Boolean,
  },
  emits: ["deletePackage", "copyLink"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;

  const emit = __emit;
  const store = useStore();

  const loading = ref(true);
  const toast = useToast();
  const siteCosts = ref<number | null>(null);

  const onDeletePackage = (id: string) => {
    emit("deletePackage", id);
  };

  const onCopyLinkPackage = (savedPackage: BuilderQuote) => {
    emit("copyLink", savedPackage);
  };

  const getSiteCosts = async () => {
    loading.value = true;

    try {
      const response = await store.dispatch("builder/getSiteCost", {
        lotId: props.savedPackage.selections.lot.lotId,
        builderId: props.savedPackage.selections.builder.builderId,
        houseId: props.savedPackage.selections.house.houseId,
      });

      siteCosts.value = response.data.siteCost;
    } catch (error) {
      toast.error("Fetching site costs failed");
    } finally {
      loading.value = false;
    }
  };

  onMounted(() => {
    if (props.savedPackage) {
      getSiteCosts();
    }
  });

const __returned__ = { props, emit, store, loading, toast, siteCosts, onDeletePackage, onCopyLinkPackage, getSiteCosts, onMounted, ref, get useToast() { return useToast }, get useStore() { return useStore }, get BuilderQuote() { return BuilderQuote }, get calculateBuildPriceOrPackagePriceTotal() { return calculateBuildPriceOrPackagePriceTotal } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})